export function handleMenuToggle() {
    const headerBurger = document.querySelector('.header_burger');
    const headerMenu = document.querySelector('.header_menu');
    const body = document.body;
    const root = document.documentElement;

    const syncScrollLock = () => {
        const isMenuOpen = Boolean(headerMenu?.classList.contains('active'));
        body.classList.toggle('lock', isMenuOpen);
        root.classList.toggle('lock', isMenuOpen);
    };

    if (headerBurger && headerMenu) {
        headerBurger.addEventListener('click', () => {
            headerBurger.classList.toggle('active');
            headerMenu.classList.toggle('active');
            syncScrollLock();
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth > 1010) {
                headerBurger.classList.remove('active');
                headerMenu.classList.remove('active');
                syncScrollLock();
            }
        });
    }
}
